<div
  class="modal fade"
  id="myModal"
  #myModal
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  aria-hidden="true"
>
  <div
    class="modal-dialog"
    [ngClass]="{
      'modal-xsmall': size === 'xs',
      'modal-small': size === 'sm',
      'modal-medium': size === 'md',
      'modal-large': size === 'lg',
      'modal-xl': size === 'xl'
    }"
  >
    <div class="modal-content modal-overflow">
      <div class="modal-header">
        <ng-content select="[header]"></ng-content>
        <button type="button" class="close" (click)="cancel()">&times;</button>
      </div>
      <div class="modal-body" style="overflow-y: auto">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</div>
